import { getCatalog } from '../../../api/movies/index';
import { store } from '../../../utils/globalData';
import VODComponent from '../../MyList/components/VODComponent';
import { Row } from '@lightningjs/ui-components';

const ROW_SIZE = 4;
const ITEM_HEIGHT = 222;
const ITEM_WIDTH = 393;
const ITEM_SPACING = 30;

export default async function (page) {
  try {
    let data = store.getData();

    if (!data) {
      console.log('Nema u store, preuzimam podatke...');
      const catalogData = await getCatalog();
      data = catalogData.data;
      store.setData(data);
      store.setMyListFlag(true);
    } else {
      console.log('Podaci su već u store');
    }
    const collections = data.index.collections;
    if (!collections) return;

    const collectionValues = Object.values(collections);
    const totalCollections = collectionValues.length;

    const rows = [];
    for (let i = 0; i < totalCollections; i += ROW_SIZE) {
      rows.push(collectionValues.slice(i, i + ROW_SIZE));
    }

    // Generate items with rowIndex and index
    const items = rows.map((row, rowIndex) => ({
      h: ITEM_HEIGHT + ITEM_SPACING,
      type: Row,
      collision: true,
      style: {
        itemSpacing: ITEM_SPACING,
      },
      items: row.map((collection, index) => ({
        collision: true,
        type: VODComponent,
        src: collection['screenshot.expiring_url'],
        h: ITEM_HEIGHT,
        w: ITEM_WIDTH,
        title: collection.name,
        index,
        rowIndex,
        data: {
          id: collection.id,
          kind: collection.kind,
        },
      })),
    }));

    // Assign once to page
    page.collections = collections;
    page._Column.items = items;
  } catch (error) {
    console.error('Error fetching catalog:', error);
  }
}
